import React from 'react';
import i18n from '@i18next/i18n';
import { Controller, IDynamicLoader, Loader, Menu, awaitLoad, skipWithDefault } from '@tencent/workbench';
import { MENU_CONFIGS } from './config';
import { IAnonymousViewFeature, loadAnonymousViewFeature } from './anonymous-view-interface';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import style from './style.less';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Controller({ menuItems: MENU_CONFIGS })
export class AnonymousViewController {
    public constructor(@Loader(IAnonymousViewFeature) private loader: IDynamicLoader<IAnonymousViewFeature>) {
        loadAnonymousViewFeature().then((feature) => {
            if (!shouldDisableNetwork() && !ENV.IS_LOCAL_EDIT) {
                feature.initAnonymousService();
            }
        });
    }

    @Menu(MenuKey.ANONYMOUS_VIEW, 'shouldHide')
    public hideAnonymousView(): boolean {
        return !(DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.anonymousView) ?? false);
    }

    @Menu(MenuKey.ANONYMOUS_VIEW, 'shouldDisabled')
    public shouldDisabled(): boolean {
        return !SlideDataServices.PrivilegeManager()?.getPrivilegeAttribute().can_invisible_visit;
    }

    @Menu(MenuKey.ANONYMOUS_VIEW, 'description')
    @awaitLoad()
    @skipWithDefault(<div></div>)
    public anonymousViewDescription() {
        return this.feature.getDescription();
    }

    @Menu(MenuKey.ANONYMOUS_VIEW, 'content')
    public getPCMenuContent() {
        return <div className={style['anonymous-view-menu']}>
            <div className={style['main-title']}>{i18n.t('隐身查看')}</div>
            <div className={style['beta-tag']}></div>
        </div>;
    }

    private get feature() {
        return this.loader.instance!;
    }
}
